import { setReviews } from "../../Redux/UserSlice/userSlice";
import { sendGetCallToSever } from "../Axios/Axios";

const GetReviews = () => (dispatch) => {
  return sendGetCallToSever("reviews").then((result) => {
    dispatch(setReviews(result.data));
  });
};

export { GetReviews };
